import React from "react";

const AgentAgreementSigningInstructions = () => (
  <div className="agent-agreement-signing-instructions bg-light border rounded-3 p-3 mb-3">
    <h5 className="mb-2">How to Sign This Agreement</h5>
    <p className="mb-3">
      Please follow these steps to complete the signing process:
    </p>
    <ol className="mb-3 ps-3">
      <li className="mb-2">
        <strong>Draw your initials</strong>
        <ul className="mb-0 mt-1">
          <li>Use your mouse to draw your initials in the designated box.</li>
          <li>Click <strong>Save Initials</strong> when you are finished.</li>
        </ul>
      </li>
      <li className="mb-2">
        <strong>Draw your signature</strong>
        <ul className="mb-0 mt-1">
          <li>Click the <strong>Signature</strong> button.</li>
          <li>Use your mouse to draw your signature in the designated box.</li>
          <li>Click <strong>Save Signature</strong> when you are finished.</li>
        </ul>
      </li>
      <li className="mb-0">
        <strong>Complete the agreement</strong>
        <ul className="mb-0 mt-1">
          <li>Read the entire agreement carefully.</li>
          <li>
            Once you have finished reading and are ready to complete the
            agreement, click the <strong>Sign Agreement</strong> button.
          </li>
        </ul>
      </li>
    </ol>
    <p className="mb-0 small text-muted">
      Your signature will then be submitted and the signing process will be
      complete.
    </p>
  </div>
);

export default AgentAgreementSigningInstructions;
